<template>
  <div>
    <div id="footer">
      <div class="container">
        <div class="col-xs-12 col-sm-12 col-md-6">
          <br>
          <div class="logo_title">
            <p>地址：上海市宝山区爱辉路201号2幢、3幢</p>
            <p>电话：021-51853815</p>
            <p>http://www.yxgene.cn</p>
            <p>邮箱: infor@sinochrome.cn</p>
          </div>
        </div>
        <div class="col-xs-12 col-sm-hidden col-md-6">
          <br>
          <div class="logo">
            <img src="@/assets/img/logo.png" alt="logo图" style="height: 120px;width: auto">
          </div>
        </div>
      </div>
    </div>
    <p class="copy">Copyright &copy; 2018 - {{ new Date().getFullYear() }} 雨琪生物 <a style="white-space: nowrap;" href="https://beian.miit.gov.cn">沪ICP备11005475号-6</a></p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  font-size: 15px;
  width: 100%;
  height: 200px;
  color: #ad997a;
  background-color: rgba(0, 0, 0, 0.03);
/*  background: #ad997a;*/
  overflow: hidden;
}
.logo {
  margin-top: 20px;
  width:400px;
}
.logo img {
  float: right;
}
.logo_title{
  padding-left: 100px;
  margin-top: 20px;
  width: 400px;
  line-height: 16px;
}
#footer table{
  margin-top: 30px;
  width: 510px;
}

#footer table th{
  width: 170px;
  font-size: 28px;
  padding-bottom:30px ;
}
#footer table td{
  font-size: 18px;
  padding: 5px;

}

.copy {
  color: #000000;
  font-size: 14px;
  margin: auto;
  text-align: center;
}
@media screen and (max-width: 997px) {
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
  .logo_title{
    padding-left: 0;
    margin-top: 0;
    width: 100%;
    line-height: 16px;
  }
  .logo {
    display: none;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue